<template>
    <div class="calendar-box">
        <HeaderNav
            header-title="考勤打卡"
            left-icon-name="2"
            right-icon-name="3"
        ></HeaderNav>
        <div class="clock-con">
            <div class="header">
                <span class="head-icon">{{ Name|headerPortFilter }}</span>
                <div class="name">
                    <h4>{{ Name }}</h4>
                    <div>{{ RoleNames }}</div>
                </div>
                <div class="time">
                    <span>{{ currentDate }}</span>
                </div>
            </div>
            <div class="body">
                <div class="calendar-con">
                    <van-calendar
                        title="日历"
                        :poppable="false"
                        :show-confirm="false"
                        :style="{ height: '320rpx' }"
                        :show-title="false"
                        color="#3495FB"
                        :formatter="formatter"
                        row-height="42"
                        :min-date="minDate"
                        :max-date="maxDate"
                        :default-date="defaultDate"
                        v-if="showCalendar"
                        @select="selectDay"
                    ></van-calendar>
                    <van-icon
                        name="arrow-left"
                        size="20"
                        color="#D60110"
                        @click="getPreMonth"
                    ></van-icon>
                    <van-icon
                        name="arrow"
                        size="20"
                        color="#D60110"
                        @click="getNextMonth"
                    ></van-icon>
                    <span class="tit">{{ calendarTit }}</span>
                </div>
                <div class="split"></div>
                <div class="clockin-times">
                    <div class="tit">
                        <span class="iconfont icondaka"></span>
                        <span>今天打卡{{ attendInfo.count }}次，共计工时{{ attendInfo.man_hour }}</span>
                    </div>
                    <van-steps direction="vertical" :active="stepsActive" active-color="#3495FB">
                        <!-- <template v-if="!attendanceList">
                            <van-step>
                                <template #active-icon>
                                    <span class="iconfont iconyuandianxiao blue"></span>
                                </template>
                                <template #inactive-icon>
                                    <span class="iconfont iconyuandianxiao"></span>
                                </template>
                                <h3>上班打卡</h3>
                            </van-step>
                        </template> -->
                        <template v-if="attendanceList">
                            <van-step v-for="(item, index) in attendanceList" :key="index">
                                <template #active-icon>
                                    <span class="iconfont iconyuandianxiao blue"></span>
                                </template>
                                <template #inactive-icon>
                                    <span class="iconfont iconyuandianxiao"></span>
                                </template>
                                <h3>{{ item.type===0?'上班打卡':'下班打卡' }} </h3>
                                <p class="time">
                                    <span class="iconfont iconshijian"></span>
                                    <span class="info">打卡时间 {{ item.created }}</span>
                                </p>
                                <p class="address" @click="toAddress(item)">
                                    <span class="iconfont iconweizhi1"></span>
                                    <span class="info">{{ item.address }}</span>
                                </p>
                            </van-step>
                        </template>
                    </van-steps>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HeaderNav } from '@/components/';
import { Toast } from 'vant';
import utils from '@/assets/js/utils';
export default {
    components: { HeaderNav },
    props: {},
    data() {
        return {
            active: 1, // 底部选项卡选中index
            activeNames: '1',
            minDate: null,
            maxDate: null,
            defaultDate: new Date(),
            stepsActive: 1, // 步骤条选中
            year: '', // 年
            month: '', // 月
            calendarTit: '', // 副标题内容
            showCalendar: false,
            attendanceDays: [],
            Name: '', // 用户名
            RoleNames: '', // 用户角色
            currentDate: '', // 当天
            attendanceList: null, // 打卡记录列表
            attendInfo: { // 打卡次数/时长
                count: 0,
                man_hour: '0',
            },
        };
    },
    watch: {},
    computed: {},
    filters: {
        headerPortFilter(value) {
            let str = '';
            if (value) {
                str = value.substr(value.length - 1, 1);
            }
            return str;
        },
    },
    methods: {
        // 格式化渲染月历
        formatter(day) {
            const date = day.date.getDate();
            const arr = this.attendanceDays.filter(item => item === date);
            if (arr.length > 0) {
                day.className = 'late';
                day.bottomInfo = '';
            }
            return day;
        },
        // 查看定位
        toAddress(data) {
            this.$router.isBack = 2;
            this.$router.push({ name: 'clockInAddress', params: { address: data.address, longitude: data.longitude, latitude: data.latitude } });
        },
        // 获取指定年月的最后一天
        getLastDay(year, month) {
            let new_year = year;
            let new_month = month++;
            if (month > 12) {
                new_month -= 12;
                new_year++;
            }
            const new_date = new Date(new_year, new_month, 1);
            return (new Date(new_date.getTime() - 1000 * 60 * 60 * 24)).getDate();
        },
        // 获取上个月
        async getPreMonth() {
            this.month--;
            if (this.month === 0) {
                this.month = 12;
                this.year--;
            }
            const attendance = await this.getAttendanceMonth();
            if (attendance) {
                this.attendanceDays = [];
                attendance.map(item => {
                    // eslint-disable-next-line radix
                    const day = parseInt(item.split('-')[2]);
                    this.attendanceDays.push(day);
                });
                this.minDate = new Date(this.year, this.month - 1, 1);
                this.maxDate = new Date(this.year, this.month - 1, this.getLastDay(this.year, this.month));
                this.calendarTit = this.year + '年' + this.month + '月';
            }
        },
        // 获取下个月
        async getNextMonth() {
            this.month++;
            if (this.month === 13) {
                this.month = 1;
                this.year++;
            }
            const attendance = await this.getAttendanceMonth();
            if (attendance) {
                this.attendanceDays = [];
                attendance.map(item => {
                    // eslint-disable-next-line radix
                    const day = parseInt(item.split('-')[2]);
                    this.attendanceDays.push(day);
                });
                this.minDate = new Date(this.year, this.month - 1, 1);
                this.maxDate = new Date(this.year, this.month - 1, this.getLastDay(this.year, this.month));
                this.calendarTit = this.year + '年' + this.month + '月';
            }
        },
        // 查询月度打卡情况
        getAttendanceMonth() {
            return this.$axios
                .get('/interfaceApi/logistics/attendance_manager/get_attendance_month/' + this.year + '/' + this.month);
        },
        // 锁定时间处理
        parseLockTime(difftime) {
            let days = 0; let hours = 0; let minutes = 0; let
                seconds = 0;
            this.attendInfo.man_hour = '';
            // eslint-disable-next-line radix
            days = parseInt(difftime / 86400); // 天  
            // eslint-disable-next-line radix
            hours = parseInt(difftime / 3600) - 24 * days; // 小时 60*60 总小时数-过去的小时数=现在的小时数 
            // eslint-disable-next-line radix
            minutes = parseInt(difftime % 3600 / 60); // 分钟 -(day*24) 以60秒为一整份 取余 剩下秒数 秒数/60 就是分钟数
            // eslint-disable-next-line radix
            seconds = parseInt(difftime % 60); // 以60秒为一整份 取余 剩下秒数
            if (days > 0) {
                // eslint-disable-next-line radix
                this.attendInfo.man_hour += parseInt(days) + '天';
            }
            if (hours > 0) {
                this.attendInfo.man_hour += hours + '小时';
            }
            if (minutes > 0) {
                this.attendInfo.man_hour += minutes + '分钟';
            }
        },
        // 查询打卡记录
        getAttendance() {
            this.$axios
                .get('/interfaceApi/logistics/attendance_manager/get_attendance/' + this.currentDate + '/1')
                .then(res => {
                    if (res.list) {
                        this.attendanceList = res.list;
                        this.stepsActive = res.list.length - 1;
                    } else {
                        this.attendanceList = null;
                    }
                    this.attendInfo.count = res.count;
                    if (res.man_hour > 0) {
                        // this.attendInfo.man_hour = (res.man_hour / 60 / 60).toFixed(2);
                        this.parseLockTime(res.man_hour);
                    }
                })
                .catch(error => {
                    this.$toast(error.ErrorCode.Message);
                });
        },
        // 点击日历切换数据
        selectDay(val) {
            const date = new Date(val).getDate();
            this.currentDate = this.year + '-' + this.month + '-' + date;
            this.getAttendance();
        },
    },
    created() {
        // 初始化当前月打卡信息
        const date = new Date();
        this.year = date.getFullYear();
        this.month = date.getMonth() + 1;
        this.$axios
            .get('/interfaceApi/logistics/attendance_manager/get_attendance_month/' + this.year + '/' + this.month)
            .then(res => {
                if (res) {
                    this.attendanceDays = [];
                    res.map(item => {
                        // eslint-disable-next-line radix
                        const day = parseInt(item.split('-')[2]);
                        this.attendanceDays.push(day);
                    });
                }
                this.minDate = new Date(this.year, this.month - 1, 1);
                this.maxDate = new Date(this.year, this.month - 1, this.getLastDay(this.year, this.month));
                this.calendarTit = this.year + '年' + this.month + '月';
                this.showCalendar = true;
            })
            .catch(error => {
                this.$toast(error.ErrorCode.Message);
            });
        // 头部用户信息
        this.Name = this.$takeTokenParameters('Name');
        this.RoleNames = this.$takeTokenParameters('RoleNames');
        this.currentDate = utils.currentTimeFormat('yyyy-MM-dd HH:mm:ss').split(' ')[0];
        // 今天打卡记录
        this.getAttendance();
    },
    mounted() {},
};
</script>
<style lang="stylus">
.calendar-box
    padding-top 44rpx
    height calc(100% - 44rpx)
    display flex
    flex-direction column
    .clock-con
        height 100%
        .header
            flex 1
            height 60rpx
            padding 10rpx
            border-bottom 1px solid #F0F0F0
            display flex
            justify-content space-between
            .head-icon
                width 40rpx
                height 40rpx
                border-radius 50%
                background-color #3495FB
                display inline-block
                text-align center
                line-height 40rpx
                color #fff
                flex none
            .name
                flex 0 0 50%
                h4
                    font-size 16rpx
                div
                    font-size 14rpx
                    color #979EA7
            .time
                flex none
                font-size 14rpx
                color #979EA7
                line-height 32rpx
                .iconfont
                    font-size 14rpx
                    margin-left 5rpx
        .body
            height calc(100% - 60rpx)
            .split
                height 5px
                background-color #F0F0F0
            .clockin-times
                height calc(100% - 325px)
                overflow hidden
                .tit
                    height 42rpx
                    border-bottom 1px solid #F0F0F0
                    font-size 14rpx
                    line-height 42rpx
                    padding 0 10rpx
                    .icondaka
                        font-size 15rpx
                        color #3495FB
                        margin-right 10rpx
                .van-steps
                    height calc(100% - 42rpx)
                    overflow-y auto
                    overflow-x hidden
                .iconyuandianxiao
                    font-size 20rpx
                    color #979EA7
                    &.blue
                        color #3495FB
                .van-step--vertical
                    .van-step__line
                        left -16rpx
                        background #E5E9F2!important
                .van-step--finish
                    color #969799
                .van-step__title--active
                    h3
                        color #969799!important
                    p
                        color #969799!important
                        line-height 30rpx
                        .iconfont
                            font-size 14rpx
                            margin-right 5rpx
                            &.icondingwei_bendi
                                font-size 18rpx
                        .info
                            color #333333!important
                .van-step__title
                    h3
                        color #969799!important
                    p
                        color #969799!important
                        line-height 30rpx
                        .iconfont
                            font-size 14rpx
                            margin-right 5rpx
                            &.icondingwei_bendi
                                font-size 18rpx
                        .info
                            color #333333!important
            .calendar-con
                position relative
                .van-icon
                    position absolute
                    top 10rpx
                .van-icon-arrow
                    right 10rpx
                .van-icon-arrow-left
                    left 10rpx
                .tit
                    position absolute
                    width calc(100% - 80rpx)
                    left 40rpx
                    height 20rpx
                    top 10rpx
                    text-align center
                    background #fff
                .van-calendar__selected-day
                    width 25rpx
                    height 25rpx
                    border-radius 50%
                .van-calendar__top-info
                    display none
</style>
<style>
.calendar-box .van-cell:not(:last-child)::after{
    left: 0;
}
.calendar-box .van-cell{
    font-size: 16rpx;
}
.calendar-box .van-calendar__day.late{
    color: #17BC84;
}
.calendar-box .van-calendar__day.notWork{
    color: #D60110;
}
.calendar-box .van-calendar__day{
    position: relative;
}
.calendar-box .van-calendar__selected-day{
    /* border-radius: 50%; */
}
.calendar-box .van-calendar__top-info{
    top:0;
}
.calendar-box .clock-con .body .calendar-con .van-calendar__day .van-calendar__selected-day .van-calendar__top-info{
    display: block;
}
.calendar-box .van-calendar__day.late::after{
    content: ' ';
    width: 6rpx;
    height: 6rpx;
    background: url(./../../../assets/images/home_sj/late_dot.png) no-repeat;
    background-size: 100% 100%;
    position: absolute;
    bottom: 0;
    left: 23.5rpx;
}
</style>